import React, { useState, useEffect } from 'react';
import pic1 from '../assets/poster.jpg.jpeg';
import './PopupModal.css';

const PopupModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const closePopup = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        closePopup();
      }
    };

    if (isVisible) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-modal">
        {/* Close Button */}
        <button className="close-btnpop" onClick={closePopup} aria-label="Close">
          ✕
        </button>

        {/* Image */}
        <div className="popup-image">
          <img src={pic1} alt="Poster" />
        </div>

        {/* Button */}
        <div className="popup-buttons">
          <a 
          href='https://bihanishikshatrust.com/olympiad'
          className="btn btn-get-started" 
          >
            Tap to Register
          </a>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;